/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

'use strict';

var ReactMount = require('./ReactMount');

module.exports = ReactMount.renderSubtreeIntoContainer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dom/lib/renderSubtreeIntoContainer.js
 ** module id = ./node_modules/react-dom/lib/renderSubtreeIntoContainer.js
 ** module chunks = 1
 **/